import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { Card, Col, Container, Row } from "react-bootstrap";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";
import { t } from "i18next";
import GlobalProgressOverlay from "../components/Admin/Reusable/GlobalProgressOverlay";
import InputField from "../components/Admin/Reusable/InputField";
import { basicFormValidationHandler } from "../utils";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import { useDispatch } from "react-redux";
import { fetchPageById, fetchUpdatePage } from "../actions/page";
import { useSelector } from "react-redux";
import { pageActions } from "../reducers/page";

const PagesAdd = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pageDetail, loading, success, actionType } = useSelector(
    (state) => state.pageReducer
  );

  //breadcrumbs
  const translateForm = "pageForm";
  const translateModule = "page";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    title: "",
    content: "",
  };

  //osnovi podaci
  const [data, setData] = useState(initialState);
  const [progress, setProgress] = useState(0);
  const [errors, setErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    dispatch(fetchPageById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (pageDetail && id) {
      setData({
        ...pageDetail,
      });
    }
  }, [pageDetail, id, dispatch]);

  const clientValidationHandler = () => {
    const { title, content } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      title,
      content,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  useEffect(() => {
    let interval;
    let timeout;

    if (loading) {
      setShowLoader(true);
      setProgress(0);

      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 5;
        });
      }, 100);
    } else if (!loading && showLoader) {
      setProgress(100);
      timeout = setTimeout(() => {
        setShowLoader(false);
        setProgress(0);
      }, 2000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [loading]);

  useEffect(() => {
    if (success) {
      const timeout = setTimeout(() => {
        navigate("/pages-list");

        if (actionType === "update") {
          toast.success("Uspešno ste izmenili stranicu", { theme: "colored" });
        }

        dispatch(pageActions.clearError());
      }, 2000);

      return () => clearTimeout(timeout);
    } else {
      dispatch(pageActions.clearError());
    }
  }, [success]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    dispatch(fetchUpdatePage(data, id));
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={`${translateModule}${pageType}`}
        id={id}
        pageType={pageType}
      />
      {showLoader && <GlobalProgressOverlay progress={progress} />}
      <Container className="page-container">
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Card>
                  <Card.Header>
                    <FormTitleMain />
                  </Card.Header>
                  <Card.Body>
                    <Col lg={12} md={12} xs={12} className="mb-4">
                      <InputField
                        label={"Naslov"}
                        name="title"
                        value={data.title}
                        onChange={handleInputChange}
                        error={errors}
                        errorsHandler={setErrors}
                        fullWidth
                        size="small"
                        required
                      />
                    </Col>

                    <Col lg={12} className="mb-3">
                      <label className="form-label">Sadržaj stranice *</label>
                      <CKEditor
                        name="content"
                        editor={Editor}
                        data={data.content ?? ""}
                        onReady={(editor) => {}}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setData((prevData) => ({
                            ...prevData,
                            content: data,
                          }));
                        }}
                      />
                      {errors.content && (
                        <span className="error">{errors.content}</span>
                      )}
                    </Col>
                  </Card.Body>
                </Card>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default PagesAdd;
